import React, { useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { TextField, LoadingSpinner, Icon } from '@doxyme/ui';
import './password.scss';
export const PasswordField = React.forwardRef((props, ref) => {
    const intl = useIntl();
    const [type, setType] = useState('password');
    const { loading, ...restProps } = props;
    const toggleLabel = intl.formatMessage({ id: 'auth.sign-up.password.toggle' });
    const btn = (<>
        {loading && <LoadingSpinner className="password-spinner" size="small"/>}
        <button tabIndex={-1} className="password-button" type="button" aria-label={toggleLabel} aria-pressed={type === 'text'} onClick={() => setType(type === 'password' ? 'text' : 'password')}>
          {type === 'password' ? <Icon name="password-hide" size="x-small"/> : <Icon name="password-show" size="x-small"/>}
        </button>
      </>);
    const handleClipboardEvent = useCallback((e) => {
        if (type === 'password') {
            e.preventDefault();
        }
    }, [type]);
    return (<TextField ref={ref} {...restProps} type={type} endAdornment={btn} autoComplete="off" onCopy={handleClipboardEvent}/>);
});
